export default __webpack_public_path__ + "static/media/55.32a57989.jpg";